import { FC } from 'react';

export const TWO_TONE_BG_CLASSNAME = 'two-tone-background';
export const TWO_TONE_CLASSNAME = `.${TWO_TONE_BG_CLASSNAME}`;

export const TwoToneBackground: FC = () => (
  <svg
    width="100%"
    height="100%"
    style={{ pointerEvents: 'none', position: 'absolute', transform: 'rotate(180deg)' }}
    viewBox="0 0 100 100"
    fill="none"
    preserveAspectRatio="none"
    xmlns="http://www.w3.org/2000/svg"
    className={TWO_TONE_BG_CLASSNAME}
  >
    <path d="M0 100V0H100L0 100Z" />
  </svg>
);
